exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert h4[data-v-2f54efe3]{font-weight:700}.alert .btn-group[data-v-2f54efe3]{margin-top:1em}.alert .btn-group .btn[data-v-2f54efe3]{margin-right:.5em}.alert .btn-group .btn[data-v-2f54efe3]:last-child{margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f54efe3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Alert.vue
// module id = 165
// module chunks = 0